<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(DestinyMatrixKeysEnum.PROGRAMS);
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{ t("calculators.destiny-matrix.accordions.programs") }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-4 sf-pro">
        <div v-for="(program, key) in description" :key="key">
          <p class="text-xl font-bold pt-4 mb-2">
            {{ program["title"] }}
          </p>
          <div class="whitespace-pre-line">
            {{ program["desc"] }}
          </div>
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
